import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '@env/environment';

export const authCodeFlowConfig: AuthConfig = {
  issuer: environment.API_AUTH_BASE,
  loginUrl: `${environment.API_AUTH_BASE}/op/authorize`,
  logoutUrl: `${environment.API_AUTH_BASE}/op/logout`,
  tokenEndpoint: `${environment.API_AUTH_BASE}/op/token`,
  userinfoEndpoint: `${environment.API_AUTH_BASE}/op/userinfo`,
  redirectUri: `${window.location.origin}/v1/auth/callback`,
  clientId: environment.clientId,
  responseType: 'code',
  scope: 'openid profile email offline_access',
  useSilentRefresh: false,
  timeoutFactor: 0.75,
  clockSkewInSec: 60,
  decreaseExpirationBySec: 0,
  requireHttps: environment.production,
  dummyClientSecret: '',
  showDebugInformation: !environment.production,
  skipIssuerCheck: true,
  disableAtHashCheck: true,
};
